import React from 'react';
import CollapsibleItem from '../components/CollapsibleItem';
import SelectInput from '../components/SelectInput';
import {wagesQuestions, wagesOptions, sectionIds, wagesIds} from '../constants';
import { useSelector, useDispatch } from 'react-redux';
import { updateParents } from '../actions/parents';
import { updateSection } from '../actions/ui';

const WagesSalaries = () => {
  const dispatch = useDispatch();
  const parents = useSelector((state) => state.parents.parents);

  const updateFrequency = (index,option) => {
    dispatch(updateParents(index,'frequencyIncome',option.id));
    dispatch(updateSection(sectionIds.WAGES_AND_SALARIES));
  }

  const updateHours = (index, amount) => {
    dispatch(updateParents(index,'hours',amount));
    dispatch(updateSection(sectionIds.WAGES_AND_SALARIES));
  }

  const updateIncome = (index, income) => {
    let newIncome = (income<0 || (isNaN(income) && income!=='')) ? 0 : income ;
    dispatch(updateParents(index,'grossIncome',newIncome));
    dispatch(updateSection(sectionIds.WAGES_AND_SALARIES));
  }


  return (
    <CollapsibleItem
      id={sectionIds.WAGES_AND_SALARIES}
    >
      {parents.map((item,index) => (
      <>
        <SelectInput
          label={wagesQuestions(item.name)}
          options={Object.values(wagesOptions)}
          initialOption={wagesOptions[item.frequencyIncome].value}
          isCurrency
          onChangeOption={(option)=>updateFrequency(index,option)}
          onChangeInput={(income)=>updateIncome(index,income)}
          valueInput={item.grossIncome}
          valueOption={wagesOptions[item.frequencyIncome]}
          initalValue=''
          widthInput={112}
          widthDropdown={187}
        />
        { (item.frequencyIncome===wagesIds.HOURLY) && (
            <SelectInput
              label='How many hours does the parent work?'
              options={[{label:'hours per week', index:0,value:0}]}
              justLabel
              onChangeOption={(option)=>updateFrequency(index,option)}
              typeInput="number"
              onChangeInput={(amount)=>updateHours(index,amount)}
              valueInput={item.hours}
              minInput={1}
              maxInput={80}
              widthInput={112}
              widthDropdown={187}
            />
          )
        }
      </>
      ))
      }

    </CollapsibleItem>
  )
}

export default WagesSalaries;

